import React from 'react';
import styles from './FormTitle.module.scss';
import classnames from 'classnames'

interface Props {
    title: string;
    message?: string;
    size?: 'medium' | 'large';
    className?: string;
}

const FormTitle = ({ title, message, size, className }: Props) => {
    const titleClassName = classnames(className, styles.title, {
        [styles[`title--${size}`]]: !!size
    });

    return (
        <div className={styles.wrapper}>
            <h1 className={titleClassName}>{title}</h1>
            {message && <span className={styles.message}>{message}</span>}
        </div>
    )
}

export default FormTitle
